export type AllocationBlock = {
  name: string;
  count: number;
  ids: string[];
};

export type AllocationFile = {
  path: string;
  host: string;
  exists: boolean;
  bytes: number | null;
  mtime: string | null;
  error: string | null;
  timezone: string | null;
  active_block: string | null;
  current_block: string;
  load_balance: string[];
  blocks: AllocationBlock[];
  lines: number;
  preview: string;
  truncated: boolean;
};

export type InFcrLoad = {
  count: number;
  field: string;
  filter: string;
  chargepoints_seen: number;
  duplicates_dropped: number;
  copied_to: string[];
};

export async function fetchAllocation(): Promise<AllocationFile> {
  const res = await fetch("/api/allocation", { credentials: "same-origin" });
  const data = (await res.json().catch(() => ({}))) as AllocationFile & { error?: string };
  if (!res.ok) {
    throw new Error(data.error || `allocation ${res.status}`);
  }
  return data;
}

export async function loadInFcrAllocation(): Promise<AllocationFile & { load?: InFcrLoad }> {
  const res = await fetch("/api/allocation/load-in-fcr", {
    method: "POST",
    credentials: "same-origin",
  });
  const data = (await res.json().catch(() => ({}))) as AllocationFile & {
    error?: string;
    load?: InFcrLoad;
  };
  if (!res.ok) {
    throw new Error(data.error || `allocation load ${res.status}`);
  }
  return data;
}
